import React from 'react';
import PropTypes from 'prop-types';
import { deEnum } from '../../modules/deenum';
import { Contamination } from './contamination';
import {
    FIELD_CONTAINING_GLUTEN,
    FIELD_CONTAINING_GLUTEN_WHEAT,
    FIELD_CONTAINING_GLUTEN_RYE,
    FIELD_CONTAINING_GLUTEN_BARLEY,
    FIELD_CONTAINING_GLUTEN_OATS,
    FIELD_CONTAINING_GLUTEN_SPELT,
    GLUTEN_CROSS_CONTAMINATION,
    MILK_CROSS_CONTAMINATION
} from '../../modules/constants';

const LABELS = {
    FIELD_CONTAINING_GLUTEN,
    FIELD_CONTAINING_GLUTEN_WHEAT,
    FIELD_CONTAINING_GLUTEN_RYE,
    FIELD_CONTAINING_GLUTEN_BARLEY,
    FIELD_CONTAINING_GLUTEN_OATS,
    FIELD_CONTAINING_GLUTEN_SPELT,
    GLUTEN_CROSS_CONTAMINATION,
    MILK_CROSS_CONTAMINATION
};

/**
 * Display appropriate labels according to data coming from the API.
 *
 * @function
 * @param       {[type]} props [description]
 * @constructor
 */
function Label(props) {
    const { name, contamination, children } = props;
    if (!children) {
        return (
            <li>
                {LABELS[`FIELD_CONTAINING_${name}`] || deEnum(name)}
                <Contamination item={props} contamination={contamination} />
            </li>
        );
    }

    return (
        <li>
            {LABELS[`FIELD_CONTAINING_${name}`] || deEnum(name)}
            <ul>
                {children.map(({ name }, idx) => {
                    return (
                        <li key={`child-${idx}`}>
                            {LABELS[`FIELD_CONTAINING_${name}`] || deEnum(name)}
                        </li>
                    );
                })}
            </ul>
            <Contamination item={props} contamination={contamination} />
        </li>
    );
}

Label.propTypes = {
    name: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.object),
    contamination: PropTypes.bool
};

export { Label };
